export default __webpack_public_path__ + "static/media/UZ.41660f03.svg";